export default __webpack_public_path__ + "static/media/flag-falkland-islands-(malvinas).d72fa6b1.svg";